import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import iconMixin from 'styles/utils/iconMixin';

export const HintSpan = styled.span`
  ${iconMixin('.925rem')};
  padding-left: 0.3125rem;
  color: ${(props) => props.theme.colors.hintIcon};
  vertical-align: middle;
  line-height: inherit;
`;

const HintIcon = ({ style, hint }: { style?: React.CSSProperties; hint?: any }) => {
  if (!hint) {
    return null;
  }
  return <HintSpan style={style}>info_outline</HintSpan>;
};
HintIcon.propTypes = {
  hint: PropTypes.string,
  style: PropTypes.object,
};
HintIcon.defaultProps = {
  hint: '',
  style: {},
};
export default HintIcon;
